<div id="outstandingBalanceGraph"></div>
